function HomeImage() {
  return (
    <div className="HomeImage">
      <img src="https://i.pinimg.com/originals/8d/bc/3f/8dbc3facd0ffd156dfbf5eb42e065ec0.jpg" alt="Profile Pic" id="pfp"/>
    </div>
  );
}
export default HomeImage;